export default function mod(n, x) {
    return ((n % x) + x) % x;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/mod.js
// module id = 1383
// module chunks = 3